import React from 'react';
import {
  BottomNavigation,
  BottomNavigationAction,
  Paper,
  useMediaQuery
} from '@mui/material';
import {
  Dashboard as DashboardIcon,
  Receipt as TransactionsIcon,
  Assessment as ReportsIcon,
  People as UsersIcon,
  Settings as SettingsIcon
} from '@mui/icons-material';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

function Navigation() {
  const navigate = useNavigate();
  const location = useLocation();
  const { user } = useAuth();
  const isMobile = useMediaQuery('(max-width: 768px)');

  // Check permissions for each navigation item
  const canAccessUsers = user?.permissions?.users?.includes('read');
  const canAccessSettings = user?.permissions?.settings?.includes('read');

  if (!isMobile) {
    return null; // Only show bottom nav on mobile
  }

  const navigationItems = [
    { label: 'Dashboard', icon: <DashboardIcon />, path: '/dashboard', show: true },
    { label: 'Transactions', icon: <TransactionsIcon />, path: '/transactions', show: true },
    { label: 'Reports', icon: <ReportsIcon />, path: '/reports', show: true },
    { label: 'Users', icon: <UsersIcon />, path: '/users', show: canAccessUsers },
    { label: 'Settings', icon: <SettingsIcon />, path: '/settings', show: canAccessSettings },
  ].filter(item => item.show);

  const currentValue = navigationItems.findIndex(item => item.path === location.pathname);

  return (
    <Paper 
      sx={{ 
        position: 'fixed', 
        bottom: 0, 
        left: 0, 
        right: 0,
        zIndex: 1000 
      }} 
      elevation={3}
    >
      <BottomNavigation
        showLabels
        value={currentValue}
        onChange={(event, newValue) => {
          navigate(navigationItems[newValue].path);
        }}
      >
        {navigationItems.map((item, index) => (
          <BottomNavigationAction
            key={item.path}
            label={item.label}
            icon={item.icon}
            value={index}
          />
        ))}
      </BottomNavigation>
    </Paper>
  );
}

export default Navigation;